import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Layout from './Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Queue from './pages/Queue';
import IdeaDetail from './pages/IdeaDetail';
import ArticleDetail from './pages/ArticleDetail';
import Library from './pages/Library';
import Agents from './pages/Agents';
import Activity from './pages/Activity';
import ActivityDetail from './pages/ActivityDetail';
import Settings from './pages/Settings';
import Publications from './pages/Publications';
import PieceEditor from './pages/PieceEditor';
import Discovery from './pages/Discovery';
import { JournalDetail, JournalIndex } from './pages/Journal';
import './editorial.css';
import './workspace.css';

function PreferencesRedirect() {
  const location = useLocation();
  const incoming = new URLSearchParams(location.search);
  const target = new URLSearchParams();
  target.set('tab', 'preferences');
  const profileId = incoming.get('profileId') ?? incoming.get('profile');
  if (profileId) target.set('profileId', profileId);
  const publicationId = incoming.get('publicationId') ?? incoming.get('publication');
  if (publicationId) target.set('publicationId', publicationId);
  return <Navigate to={`/dashboard?${target.toString()}`} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/journal" element={<JournalIndex />} />
      <Route path="/journal/:id" element={<JournalDetail />} />
      <Route element={<Layout />}>
        <Route path="/dashboard" element={<Publications />} />
        <Route path="/publications" element={<Navigate to="/dashboard" replace />} />
        <Route path="/pieces/:id" element={<PieceEditor />} />
        <Route path="/preferences" element={<PreferencesRedirect />} />
        <Route path="/lessons" element={<PreferencesRedirect />} />
        <Route path="/discovery" element={<Discovery />} />
        <Route path="/queue" element={<Queue />} />
        <Route path="/ideas/:id" element={<IdeaDetail />} />
        <Route path="/articles/:id" element={<ArticleDetail />} />
        <Route path="/library" element={<Library />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/activity/:id" element={<ActivityDetail />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
